const questions = [
  {
    id: 'regions',
    question: 'Which regions are you interested in? (Select all that apply)',
    options: ['Any', 'Europe', 'Asia', 'North America', 'South America', 'Australia', 'Africa'],
    type: 'multi-select',
  },
  {
    id: 'travel_dates',
    question: 'When are you planning to travel?',
    type: 'date-range',
  },
  {
    id: 'travel_duration',
    question: 'Preferred travel duration?',
    options: ['Short (1-3 days)', 'Medium (4-7 days)', 'Long (8+ days)'],
    type: 'single-select',
  },
  {
    id: 'budget',
    question: 'What is your budget per day?',
    options: ['Budget (< $50)', 'Mid-range ($50 - $150)', 'High-range ($150 - $300)', 'Luxury (> $300)'],
    type: 'single-select',
  },
  {
    id: 'transportation',
    question: 'How will you travel whilst there?',
    options: ['Car', 'Train', 'Walking', 'Public Transport', 'Any'],
    type: 'multi-select',
  },
  {
    id: 'group_size',
    question: 'Who are you going with?',
    options: ['Solo', 'Couple', 'Family', 'Friends'],
    type: 'single-select',
  },
  {
    id: 'interests',
    question: 'What are your interests?',
    options: [
      'Culture',
      'Adventure',
      'Relaxation',
      'Food',
      'Wine',
      'History',
      'Nature & Wildlife',
      'Nightlife',
      'Shopping',
      'Sports',
      'Art & Music',
      'Beaches',
      'Mountains',
    ],
    type: 'multi-select',
  },
  {
    id: 'activities',
    question: 'Any specific activities you\'re interested in?',
    options: [
      'Hiking',
      'Diving',
      'Skiing',
      'Cultural Tours',
      'Shopping',
      'Food Tours',
      'Wildlife Safaris',
      'Beach Activities',
      'Historical Sites',
    ],
    type: 'multi-select',
  },
];

export default questions;
